import { Component, OnInit } from '@angular/core';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-admin-notifications',
  templateUrl: './admin-notifications.component.html',
  styleUrls: ['./admin-notifications.component.scss']
})
export class AdminNotificationsComponent implements OnInit {
  SessionNo: any;
  userPermission: any;
  UserCollege: any;

  constructor(private modalPopupService: ModalpopService,
    public umsService: UmsService,private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    public router: Router,
    private dialog:MatDialog,
) { }
  NotificationsData: any[];
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.getList(this.SessionNo);
    }
    
  }
  fetchSecretData() {
    this.spinner.show()
    this.umsService.getSecretData().subscribe((res) => {
      if(res.status){
        this.spinner.hide()
        this.SessionNo = res.projectPharam['SnNo']
        this.getList(this.SessionNo);
      }
      else{
        this.spinner.hide()
      }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide()
      }
    );
  }


  getList(SnNo) {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {
      CoCode: '',
      SnNo: SnNo,
      CgCode:this.UserCollege,
      ApplicationType:'Admin',
    };
  
    this.umsService.getStuNotify(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.NotificationsData = res.data
        
        } else {
          this.NotificationsData = [];
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.NotificationsData = [];
      }
    );
  }

  showbase64(e) { 

    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.DocUpload
      });
  }

  // shouldMergeRows(index: number, field: string): boolean {
  //   if (index === 0) {
  //     return true;  // Always show the first row
  //   }
  //   return this.NotificationsData[index][field] !== this.NotificationsData[index - 1][field];
  // }

  // // Function to get the rowspan for title or description
  // getRowSpan(index: number, field: string): number {
  //   if (index === 0) {
  //     return 1;  // Always show the first row
  //   }

  //   let span = 1;
  //   let currentValue = this.NotificationsData[index][field];

  //   // Calculate rowspan by checking the next rows for the same value
  //   for (let i = index + 1; i < this.NotificationsData.length; i++) {
  //     if (this.NotificationsData[i][field] === currentValue) {
  //       span++;
  //     } else {
  //       break;
  //     }
  //   }
  //   return span;
  // }



  shouldMergeRows(index: number, field: string): boolean {
    if (index === 0) {
      return true; // Always show the first row
    }
    return (
      this.NotificationsData[index][field] !==
      this.NotificationsData[index - 1][field]
    );
  }
 
  // Calculates the rowspan for a cell
  getRowSpan(index: number, field: string): number {
    let span = 1;
    const currentValue = this.NotificationsData[index][field];
 
    for (let i = index + 1; i < this.NotificationsData.length; i++) {
      if (this.NotificationsData[i][field] === currentValue) {
        span++;
      } else {
        break;
      }
    }
    return span;
  }

  getSrNo(index: number): number {
    let count = 1; // Start with Sr No 1
    for (let i = 0; i < index; i++) {
      if (this.shouldMergeRows(i, 'NotTitle')) {
        count++;
      }
    }
    return count;
  }


  convertUTCToIST(dateString: string): string {
    const utcDate = new Date(dateString); // Convert string to Date object
    // Directly use the date pipe with 'Asia/Kolkata' time zone
    return this.datePipe.transform(utcDate, 'dd/MM/yyyy', 'Asia/Kolkata') || '';
  }
 
}
